export const DIMBO_CONSTANT = {

    // API endpoints
    API_ENDPOINT: '',

    // Configs
    I18N_ENDPOINT: '/assets/i18n',
    CONFIG_ENDPOINT: '/assets/config/config.json',
    API_ENDPOINT_KEY: 'apiUrl',
    TOKEN_VALIDATE_INTERVAL_KEY: 'tokenInterval',
    PAGE_COUNT_KEY: 'pageCount' ,

    // Date Format
    DATE_FROMAT: 'dd-MM-yyyy',

    // i18n Default
    //DEFAULT_LOCALE: 'fr-FR',
    DEFAULT_LOCALE: 'en',

    //Cache Keys
    CACHE_I18N_LOCALE: 'i18n_locale',
    CACHE_I18N_DATA: 'i18n_data',
    CACHE_USER_ID: 'user_id',
    CACHE_USER_ROLE: 'user_role',
    CACHE_USER_ROLES: 'user_roles',
    CACHE_ACCESS_PATH: 'access_path',
    CACHE_QUERY_PARAMS: 'query_params',
    CACHE_IS_VALID_USER: 'is_valid_user',
    CACHE_IS_VALID_ROLE: 'is_valid_role',
    CACHE_JWT_TOKEN: 'jwt_token',
    CACHE_JWT_VIN: 'vin',

    CACHE_JWT_TOKEN_RESPONSE: 'jwt_token_response',
    CACHE_JWT_SOURCE_APPLICATION: 'jwt_token_source_application',
    CACHE_JWT_LANGUAGE: 'jwt_token_language',
    CACHE_JWT_LANGUAGE_RAW: 'jwt_token_language_raw',
    CACHE_JWT_REPAIRER_COUNTRY: 'jwt_token_repairer_country',
    CACHE_JWT_CUSTOMER_EMAIL: 'jwt_token_customer_email',
    CACHE_JWT_CUSTOMER_LAST_NAME: 'jwt_token_customer_last_name',
    CACHE_JWT_REPAIRER_NAME: 'jwt_token_repairer_name',
    CACHE_JWT_REPAIRER_CITY: 'jwt_token_repairer_city',
    CACHE_JWT_REPAIRER_ADDRESS: 'jwt_token_repairer_address',
    CACHE_JWT_REPAIRER_ZIP: 'jwt_token_repairer_zip',
    CACHE_JWT_MILEAGE: 'jwt_token_mileage',
    CACHE_JWT_MILEAGE_UNIT: 'jwt_token_mileage_unit',

    CACHE_JWT_USER_ID: 'jwt_token_user_id',
    CACHE_JWT_POS: 'jwt_token_pos',
    CACHE_JWT_RRDI: 'jwt_token_rrdi',
    CACHE_JWT_PHYSICAL_SITE: 'jwt_token_physical_site',

    CACHE_IS_CUSTOMER_VERIFIED: 'is_customer_verified',
    CACHE_BRAND: 'brand',
    CACHE_CONTRACT_ID: 'contractId',
    CACHE_REGISTRATION: 'registration',
    CACHE_FIRST_REGISTRATION_DATE: 'first_registration_date',
    CACHE_CURRENT_MILEAGE: 'currrent_mileage',
    CACHE_MILEAGE_UNIT: 'mileage_unit',
    CACHE_IS_CENTRAL_USER: 'is_central_user',
    CACHE_IS_ADMIN_USER: 'is_admin_user',
    CACHE_IS_READ_ONLY: 'is_read_only',
    CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT: 'customer_verification_retry_count',
    CACHE_VECHILE_MILEAGE: 'vechile_mileage',
    CACHE_VECHILE_MILEAGE_UNIT: 'vechile_mileage_unit',
    CACHE_SHE_COMMENT: 'service_history_edit_commnet',
    CACHE_SHE_AP_COMMENT: 'service_history_edit_ap_commnet',
    CACHE_SHE_AP_CHECK: 'service_history_edit_ap_check',
    CACHE_SHE_AP_PERIOD: 'service_history_edit_ap_period',
    CACHE_SHE_AP_ID: 'service_history_edit_ap_id',
    CACHE_LANGUAGE_LOCAL: 'locale',
    CACHE_CREATE_SERVICE_SCOPE: 'create_service_scope',
    CACHE_IS_MP_CALL_FIRST_TIME: 'is_mp_call_first_time',
    CACHE_IS_MP_SEVERE_HAS_DATA: 'is_mp_severe_has_data',
    CACHE_SH_SCROLL_COUNT: 'sh_scroll_count',
    CACHE_IS_SH_TAB: 'is_sh_tab',
    CACHE_CREATE_CURRENT_USAGE: 'selected_usage',
    CACHE_CIN_BRAND: 'cin_brand',
    CACHE_MILEAGE_UNIT_MATCH: 'doesMileageUnitMatch',
    CACHE_MILEAGE_UNIT_MATCH_VAL: 'frequencyMileageUnit',
    FCA_BRANDS: ['CY', 'DG', 'JE', 'RM', 'AR', 'FT', 'LA', 'AH', 'FO'],
    // API url
    AUTHENTICATE_TOKEN: '/authenticate', 
    //AUTHENTICATE_TOKEN: '/token',
    VALIDATE_TOKEN: '/validate/jwt-token',
    SERVICE_HISTORY_EP: '',
    MAINTENANCE_PLAN: '/maintenance-plans/UI',
    CUSTOMER_VERIFY: '/customer-challenge',
    EDIT_VEHICLE_INFO_CHECK:'edit_vehicle_info_check',
    CACHE_IS_OV_LEGACY: 'isOvLegacy',

    FCA_VEHICLE_INFORMATION: '/exfca/{vin}/vehicle-information'
};
